import { Helper } from '../Helper';
export class WrapArrayValHelper extends Helper {
    constructor(options) {
        super();
        this.type = options.type;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.arrMap({
            map: (innerOptions) => {
                sb.emitHelper(node, innerOptions, sb.helpers.wrapVal({ type: this.type }));
            },
        }));
        sb.emitHelper(node, options, sb.helpers.wrapArray);
    }
}

//# sourceMappingURL=WrapArrayValHelper.js.map
